import React, { useEffect, useState } from "react";
import Top_bar from "../../Components/topBar/topBar";
import BottomBar from "../../Components/bottomBar/bottomBar";
import DonutChart from "../../Components/donutChart/donutChart";
import styles from "./details.module.css";
import configUrl from "../../services/configUrl";
import { useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import io from "socket.io-client";
import api from "../../services/api";

function useQuery() {
  return new URLSearchParams(useLocation().search);
} 

function Details() {
  const query = useQuery();
  const [loading, setLoading] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [namespace, setNamespace] = useState();
  const [details, setDetails] = useState();
  const [colorOee, setColorOee] = useState();
  const [colorDisp, setColorDisp] = useState();
  const [colorQual, setColorQual] = useState();
  const [colorPerf, setColorPerf] = useState();
  const [verify, setVerify] = useState(false);

  useEffect(()=>{
    const getOEEDetails = async () =>{
      try {
        api.get('/machines/oee-details/',{params:{id_machine:query.get("id_machine")}}).then(resp=>{
          if (loading) setLoading(false);

          setNamespace(resp.data);
          handleColor(
            namespace?.oee,
            namespace?.disponibility,
            namespace?.performance,
            namespace?.quality,
            namespace?.orderPerformance
          );

        }) 
      } catch (error) {
        //alert(error)
      }
    }
    getOEEDetails();
  },[])

  useEffect(() => {
    const getDetails = async () => {
      try {
        const response = await api.get(
          `/machines/detail/${query.get("id_machine")}`
        );

        if (response.data) {
          setDetails(response.data);
          setLoadingDetails(false);
        }
      } catch (error) {
        //alert(error);
      }
    };
     let socket = io(
      `${configUrl.protocol}://${configUrl.ip}
      /machine-${query.get("id_machine")}`
    );

    socket.on("reply-namespace", (data) => {
      setNamespace(data);
      if (loading) setLoading(false);
    });
    getDetails();
    handleColor(
      namespace?.oee,
      namespace?.disponibility,
      namespace?.performance,
      namespace?.quality,
      namespace?.orderPerformance
    );
    return () => {
      socket.removeAllListeners();
      socket = null;
    };
  }, [
    namespace?.oee,
    namespace?.disponibility,
    namespace?.performance,
    namespace?.quality,
    namespace?.orderPerformance,
  ]);

  const oeecolorchart = (variable, colorValue) => {
    const color1 = "#ff0000";
    const color2 = "#ffd966";
    const color3 = "#ffc000";
    const color4 = "#2e75b6";
    const color5 = "#a9d18e";
    const color6 = "#548235";
    if (variable < 25.0) {
      if (colorValue === 0) {
        setColorOee(color1);
      } else if (colorValue === 1) {
        setColorDisp(color1);
      } else if (colorValue === 2) {
        setColorPerf(color1);
      } else if (colorValue === 3) {
        setColorQual(color1);
      } else if (colorValue === 4) {
        setColorPerfOrd(color1);
      }
    } else if (variable > 25.0 && variable < 40.0) {
      if (colorValue === 0) {
        setColorOee(color2);
      } else if (colorValue === 1) {
        setColorDisp(color2);
      } else if (colorValue === 2) {
        setColorPerf(color2);
      } else if (colorValue === 3) {
        setColorQual(color2);
      } else if (colorValue === 4) {
        setColorPerfOrd(color2);
      }
    } else if (variable > 40.0 && variable < 55.0) {
      if (colorValue === 0) {
        setColorOee(color3);
      } else if (colorValue === 1) {
        setColorDisp(color3);
      } else if (colorValue === 2) {
        setColorPerf(color3);
      } else if (colorValue === 3) {
        setColorQual(color3);
      } else if (colorValue === 4) {
        setColorPerfOrd(color3);
      }
    } else if (variable > 55.0 && variable < 70.0) {
      if (colorValue === 0) {
        setColorOee(color4);
      } else if (colorValue === 1) {
        setColorDisp(color4);
      } else if (colorValue === 2) {
        setColorPerf(color4);
      } else if (colorValue === 3) {
        setColorQual(color4);
      } else if (colorValue === 4) {
        setColorPerfOrd(color4);
      }
    } else if (variable > 70.0 && variable < 85.0) {
      if (colorValue === 0) {
        setColorOee(color5);
      } else if (colorValue === 1) {
        setColorDisp(color5);
      } else if (colorValue === 2) {
        setColorPerf(color5);
      } else if (colorValue === 3) {
        setColorQual(color5);
      } else if (colorValue === 4) {
        setColorPerfOrd(color5);
      }
    } else if (variable > 85.0) {
      if (colorValue === 0) {
        setColorOee(color6);
      } else if (colorValue === 1) {
        setColorDisp(color6);
      } else if (colorValue === 2) {
        setColorPerf(color6);
      } else if (colorValue === 3) {
        setColorQual(color6);
      } else if (colorValue === 4) {
        setColorPerfOrd(color6);
      }
    }
    setVerify(true);
  };
  const handleColor = (oee, disp, perf, qual, perf_ord) => {
    oeecolorchart(oee, 0);
    oeecolorchart(disp, 1);
    oeecolorchart(perf, 2);
    oeecolorchart(qual, 3);
    oeecolorchart(perf_ord, 4);
  };

  return (
    <>
      <Top_bar />
      <main className={styles.container}>
        <section>
          <div className={styles.card}>
            <span>Máquina</span>
            <strong>{details?.machine || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Setor</span>
            <strong>{details?.department || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Operador</span>
            <strong>{details?.operator || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Turno</span>
            <strong>{details?.work_shift+' '+ details?.start_time+' - '+details?.end_time  || "---"}
            </strong>
          </div>
          <div className={styles.card}>
            <span>Ordem - Item</span>
            <strong>{details?.production_order || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Operação - Alternativa </span>
            <strong>{details?.operation || "---"}</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido dia</span>
            <strong>{details?.productionDay || 0} pçs.</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido turno</span>
            <strong>{details?.productionWorkShift || 0} pçs.</strong>
          </div>
          <div className={styles.card}>
            <span>Total produzido ordem</span>
            <strong>{details?.produced || 0} pçs.</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado dia</span>
            <strong>{details?.scrapDay || 0} pçs.</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado turno</span>
            <strong>{details?.scrapWorkShift || 0} pçs.</strong>
          </div>
          <div className={styles.card}>
            <span>Total refugado ordem</span>
            <strong>{details?.refuse || 0} pçs.</strong>
          </div>

          {loading  ?  (
            <div
              style={{ marginTop: "20vh", marginLeft: "42vw" }}
              className={styles.loader}
            >
              <Spinner variant="success" animation="border" />
              <strong>Carregando...</strong>
            </div>
          ) : (
            <>
              <div className={`containerDetailsGraphics ${styles.card} ${styles.oee} `}>
                <span id={`${styles.oeetitle}`}>
                  <strong>OEE Turno</strong>
                </span>
                <DonutChart
                  id="oee_turno"
                  color={verify ? colorOee : "transparent"}
                  className={styles.donut}
                  value={namespace?.oee || 0}
                  valuelabel="OEE"
                />
                <DonutChart
                  id="disponibilidade"
                  color={verify ? colorDisp : "transparent"}
                  className={styles.donut}
                  value={namespace?.disponibility || 0}
                  valuelabel="Disponibilidade"
                />
                <DonutChart
                  id="performance"
                  color={verify ? colorPerf : "transparent"}
                  className={styles.donut}
                  value={namespace?.performance || 0}
                  valuelabel="Performance"
                />
                <DonutChart
                  id="Qualidade"
                  color={verify ? colorQual : "tranparent"}
                  className={styles.donut}
                  value={namespace?.quality || 0}
                  valuelabel="Qualidade"
                />
              </div>
              <div className={`${styles.card} ${styles.order}`}>
                {/*< span>Tempo Parado</span>
                <strong>{details?.produced || 0}{' '}Hrs.</strong> */}
                <span>Máq. Parada desde</span>
                <strong>{details?.stop_start_time || "---"}{' '}</strong>
               {/*  <DonutChart
                  id="performance_ordem"
                  color={verify ? colorPerfOrd : "tranparent"}
                  className={styles.donut}
                  value={namespace?.orderPerformance}
                  size={170}
                  valuelabel="Performance ordem"
                /> */}
              </div> 
            </>
          )}
        </section>
      </main>
      {loading || loadingDetails ? (
        <BottomBar
          marginT={
            window.screen.width > 1024 && window.screen.width <= 1280
              ? "8%"
              : window.screen.width > 1280 && window.screen.width <= 1440 
              ? "9.2%"
              : null
          }
        />
      ) : (
        <BottomBar
          marginT={
            window.screen.width > 1024 && window.screen.width <= 1280
              ? "12.9%"
              : window.screen.width > 1280 && window.screen.width <= 1440
              ? "6.5%"
              : null
          }
          position={"static"}
        />
      )}
    </>
  );
}

export default Details;
